<button
  type="button"
  class="mrp-input"
  [class.mrp-input--disabled]="disabled"
  [disabled]="disabled"
  [attr.aria-label]="displayLabel() || placeholder"
  (click)="toggle($event)"
>
  <span class="mrp-icon" aria-hidden="true"></span>
  <span class="mrp-value" [class.mrp-placeholder]="!displayLabel()">
    {{ displayLabel() || placeholder }}
  </span>
</button>

<p-popover #op appendTo="body" styleClass="mrp-overlay">
  <div class="mrp-panel">
    <div class="mrp-header">
      <button
        type="button"
        class="mrp-nav-btn"
        [disabled]="!canGoPrevYear()"
        (click)="prevYear()"
        aria-label="Previous year"
      >
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none">
          <path
            d="M8 1L1.5 7L8 13"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <span class="mrp-year">{{ viewYear() }}</span>
      <button
        type="button"
        class="mrp-nav-btn"
        [disabled]="!canGoNextYear()"
        (click)="nextYear()"
        aria-label="Next year"
      >
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none">
          <path
            d="M1 1L7.5 7L1 13"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="mrp-grid">
      <button
        type="button"
        *ngFor="let label of monthLabels; let i = index"
        class="mrp-month"
        [ngClass]="getMonthClasses(i)"
        (mouseenter)="onMonthHover(i)"
        (mouseleave)="onMonthLeave()"
        (click)="onMonthClick(i)"
      >
        {{ label }}
      </button>
    </div>

    <div class="mrp-footer">Select up to {{ maxRangeMonths }} months</div>
  </div>
</p-popover>
